/* eslint-disable arrow-parens */
import '@/components/style.scss'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { BrowserRouter } from 'react-router-dom'
import i18n from './i18n.json'
import Layout from '@/Layout'
import { AppProvider } from '@/hooks'
import Logo from '@/assets/img/Logo.svg'
import LogoSmall from '@/assets/img/Logo-small.svg'
import { init } from '@web3-onboard/react'
import { Networks } from '@/crypto/chain_info/networks'
import injectedModule from '@web3-onboard/injected-wallets'
// import walletConnectModule from '@web3-onboard/walletconnect'
import mewWallet from '@web3-onboard/mew-wallet'
import coinbaseWallet from '@web3-onboard/coinbase'
import enrkypt from '@web3-onboard/enkrypt'

const mewWalletModule = mewWallet()
const coinbaseWalletModule = coinbaseWallet()
const enrkyptModule = enrkypt()

/*
WALLET CONNECT V2 is not ready for prime time. It fails to accept multiple chains as options for 
user wallet. We'll have to try this again once they get their act together. Crypto is wild wild west.

const chains = Object.keys(Networks).map(c => +c);
 

const wcInitOptions = {
  projectId: '89985b48bbb929419449eff874a3fd59',
  requiredChains: [1],
  optionalChains: chains,
  dappUrl: "https://tripsha.com"
}

*/

//injected wallet is in-browser wallet (i.e. metamask). This is the only option for now. We can add
//others as people ask for them.
const injected = injectedModule()

init({
  wallets: [injected, mewWalletModule, coinbaseWalletModule, enrkyptModule], //, walletConnect],
  chains: Object.keys(Networks).map(i => {
    const n = Networks[i];
    return {
      id: i,
      token: n.currency,
      label: n.name,
      rpcUrl: n.rpcEndpoints[0],
    }
  }),
  //there are other fields you can set here. See docs here: https://onboard.blocknative.com/docs/overview/introduction#features
  appMetadata: {
    name: 'Tripsha',
    description: 'Tripsha Wallet Connector',
    icon: window.innerWidth > 768 ? Logo : LogoSmall,
  },
})

const App = () => {
  return (
    <AppProvider>
      <IntlProvider locale={'ENG'} defaultLocale="en" messages={i18n['ENG']}>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </IntlProvider>
    </AppProvider>
  )
}

export default App
